<template>
  <div class="present-contents">
    <div class="grid-equalHeight">
      <div
        v-if="extended"
        class="col-3_md-12"
      >
        <div class="present-contents__info">
          <div class="present-contents__pic-wrapper">
            <img
              v-if="type === 'level1' && sku"
              :src="`https://componata.de/lp_detail_images/lp_side_${sku}.png`"
              class="present-contents__pic"
              alt="Individuelles Präsent"
              loading="lazy"
            >

            <img
              v-else-if="pic"
              :src="pic + '?width=300'"
              class="present-contents__pic"
              alt="Individuelles Präsentx"
              loading="lazy"
            >

            <img
              v-else
              src="@/assets/images/custom-present-empty-model.png"
              srcset="@/assets/images/custom-present-empty-model.png 1x, @/assets/images/custom-present-empty-model@2x.png 2x"
              class="present-contents__pic"
              alt="Individuelles Präsent"
              loading="lazy"
            >
          </div>

          <div class="present-contents__details-wrapper">
            <h3 class="present-contents__title">{{ name }}</h3>

            <slot v-if="customPrices && customPrices.length > 0">
              <div
                v-for="(price, index) in customPrices"
                :key="index"
                class="present-contents__price"
              >
                <b>{{ price.price_line_1 }}</b>
                <small>{{ price.price_line_2 }}</small>
              </div>
            </slot>

            <slot v-else>
              <slot name="price"></slot>
            </slot>

            <p
              v-if="notes"
              class="present-contents__notes"
            >{{ notes }}</p>

            <div class="present-contents__cta">
              <slot name="cta"></slot>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="extended ? 'col-9_md-12' : 'col-12'"
      >
        <div class="grid-3_sm-2_xs-1-equalHeight">
          <div
            v-for="(product, index) in productList.filter((item) => item.type !== 'box')"
            :key="index"
            class="col"
          >
            <div class="present-contents__product">
              <article>
                <router-link :to="cLink($route.fullPath + '/' + (product.id || product.product))" class="present-contents__product-card">
                  <img
                    v-if="getFlagUrl(product.origin_iso.toLowerCase()) !== ''"
                    :src="getFlagUrl(product.origin_iso.toLowerCase())" class="present-contents__product-flag">

                  <div class="present-contents__product-pic-wrapper">
                    <img
                      :srcset="`
                        ${product.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=400&nearlossless=1&quality=80 2x,
                        ${product.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=200&nearlossless=1&quality=80 1x,
                      `"
                      :src="`${product.photos[$store.getters.groupAbb][0].original}?format=${webPFormat('jpeg')}&width=200&nearlossless=1&quality=80`"
                      class="present-contents__product-pic" :alt="product.name"
                    >
                  </div>

                  <div class="present-contents__product-info">
                    <h3 class="present-contents__product-title">{{ product.name }}</h3>
                    <p class="present-contents__product-description" v-html="productDetailStringBold1(product)"></p>
                    <div v-if="$store.getters.isAdminMode">Qty: <b>{{ product.stock_quantity }}</b></div>
                    <pre v-if="$store.getters.isAdminMode && $store.getters.getAdminData.Gerichshain[product.sku]">{{ JSON.stringify($store.getters.getAdminData.Gerichshain[product.sku], undefined, 1).replace('{', 'Gerichshain:').replace('}', '').replaceAll('"', '').replaceAll(',', '') }}</pre>
                  </div>
                </router-link>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

export default {
  name: 'PresentContents',
  mixins: [logicMixin, helperMixin],
  props: {
    // Whether to show or not details of the present such as price, notes, space for call to action, etc
    extended: {
      type: Boolean,
      default: false
    },
    sku: {
      type: String
    },
    type: {
      type: String,
      default: 'level3'
    },
    pic: {
    },
    name: {
      type: String,
      default: 'Präsent'
    },
    customPrices: {
      type: Array
    },
    products: {
    },
    notes: {
      type: String
    }
  },
  components: {
  },
  methods: {
  },
  computed: {
    productList () {
      const ret = [];

      this.products.forEach(item => {
        for (var i = 0; i < (item.quantity || 1); i++) {
          ret.push({
            ...item
          });
        }
      });

      return ret;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * PresentContents
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present content details (usually used for B2B pages)
 * @since 2021-11-18
**/

$component: 'present-contents';

.#{$component} {
  &__info {
    @include padding(map-get($spacers, 4));
    border-right: 1px solid $gray-ghost;
    border-radius: $border-radius-lg;
    background-color: $sky-lighter;
  }

  &__pic {
    display: block;
    width: 100%;
    @include margin-bottom(map-get($spacers, 3));
    image-rendering: crisp-edges;
  }

  &__title {
  }

  &__price {
    @include margin-bottom(map-get($spacers, 3));

    b,
    small {
      display: block;
    }

    b {
      @include font-size($font-size-lg);
    }

    small {
      color: $text-dimmed;
    }
  }

  &__notes {
    color: $text-muted;
    @include font-size($font-size-sm);
  }

  &__cta {
    @include margin-top(map-get($spacers, 4));
  }

  &__product {
    display: flex;

    // Perhaps an <article> tag, another wrapper or just the card itself
    > article {
      display: flex;
      width: 100%;
    }
  }

  &__product-card {
    position: relative;
    display: block;
    width: 100%;
    @include padding(map-get($spacers, 4));
    border-radius: $border-radius-lg;
    box-shadow: 7px 9px 14px 3px rgba(black, 0.04);
    color: $ink;
    transition: all ease-in-out 150ms;

    @include hover() {
      transform: scale(1.05);
      box-shadow: 7px 9px 14px 3px rgba(black, 0.08);
    }
  }

  &__product-pic-wrapper {
    max-width: 70%;
    @include margin-bottom(map-get($spacers, 4));
    margin-left: auto;
    margin-right: auto;
  }

  &__product-flag {
    position: absolute;
    @include rfs(map-get($spacers, 4), top);
    @include rfs(map-get($spacers, 4), left);
    width: 32px;
    height: 32px;
    border: 2px solid white;
    border-radius: 50%;
  }

  &__product-pic {
    max-width: 100%;
  }

  &__product-title {
    @include font-size(map-get($landing-page, 'font-size-lg'));
  }

  &__product-description {
    margin: 0;
    color: $ink-lighter;
    line-height: 140%;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__info {
      display: flex;
      flex-wrap: wrap;
      border-right: unset;
      border-bottom: 1px solid $gray-ghost;
    }

    &__pic-wrapper {
      flex: 0 1 30%;
      @include margin-right(map-get($spacers, 4));
    }

    &__details-wrapper {
      flex: 1 0 0;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    &__info {
      flex-direction: column;
    }

    &__pic-wrapper {
      flex: unset;
      width: 80%;
    }

    &__product-pic-wrapper {
      max-width: 60%;
    }
  }
}
</style>
